import { DatePicker } from '@material-ui/pickers';

export default DatePicker;
